var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated-text__container"},[_c('span',{staticClass:"animated-text"},[_vm._v(" "+_vm._s(_vm.textArray.join(''))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }